// NPM Imports
import { combineReducers } from "redux";

// Internal Imports
import AssetStore from "./AssetReducer";
import AuthStore from "./AuthReducer";
import CommonStore from "./CommonReducer";
import DashboardStore from "./DashboardReducer";
import DealTableStore from "./DealTableReducer";
import DocumentDealTableReducer from "./DocumentDealTableReducer";
import DocumentStore from "./DocumentReducer";
import EditorStore from "./EditorReducer";
import FieldsSettingStore from "./FieldsSettingReducer";
import GoogleSheetStore from "./GoogleSheetReducer";
import InboxStore from "./InboxReducer";
import KanbanStore from "./KanbanReducer";
import MetalensStore from "./MetalensReducer";
import MetaFieldStore from "./MetaFieldReducer";
import NavBarStore from "./NavBarReducer";
import NavbarWrapperStore from "./NavbarWrapperReducer";
import NotesStore from "./NotesReducer";
import OldAssetStore from "./AssetsReducer";
import OnboardingModalStore from "./OnboardingModalReducer";
import OpportunitiesStore from "./OpportunitiesReducer";
import PipelineStore from "./PipelineReducerV2";
import PricebookStore from "./PricebookReducer";
import ProductsStore from "./ProductReducer";
import QuotationStore from "./QuotationReducer";
import QuoteDocumentStore from "./QuoteDocumentReducer";
import QuotesStore from "./QuotesReducer";
import RevvSignStore from "./RevvSignReducer";
import SettingsStore from "./SettingsReducer";
import SharedDocument from "./DocumentSharedReducer";
import TemplateStore from "./TemplateReducer";
import ToolPaneStore from "./ToolPaneReducer";
import WorkFlowStore from "./WorkFlowReducer";

export default combineReducers({
  AssetStore,
  AuthStore,
  CommonStore,
  DashboardStore,
  DealTableStore,
  DocumentDealTableReducer,
  DocumentStore,
  EditorStore,
  FieldsSettingStore,
  GoogleSheetStore,
  InboxStore,
  KanbanStore,
  MetalensStore,
  MetaFieldStore,
  NavBarStore,
  NavbarWrapperStore,
  NotesStore,
  OldAssetStore,
  OnboardingModalStore,
  OpportunitiesStore,
  PipelineStore,
  PricebookStore,
  ProductsStore,
  QuotationStore,
  QuoteDocumentStore,
  QuotesStore,
  RevvSignStore,
  SettingsStore,
  SharedDocument,
  TemplateStore,
  ToolPaneStore,
  WorkFlowStore,
});
